// откладка вызова функции
export const debounce = <T extends unknown[], R>(
  func: (...args: T) => Promise<R> | R,
  timeout: number = 300,
) => {
  let timer: ReturnType<typeof setTimeout>

  return (...args: T): Promise<R> => {
    clearTimeout(timer)

    return new Promise(resolve => {
      timer = setTimeout(() => {
        const result = func(...args)
        if (result instanceof Promise) {
          result.then(resolve)
        } else {
          resolve(result)
        }
      }, timeout)
    })
  }
}
